import React, {useEffect} from "react";
import { Link, } from "react-router-dom";
import "./AISolutions.css";

const AISolutions = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="page-wrapper">
      <div className="page-container">
        
        {/* Back Navigation */}
        <div className="ai-back-link">
          <Link to="/">← Back to Home</Link>
        </div>

        {/* Hero Section */}
        <div className="page-hero">
          <h1>Revolutionizing Business with AI</h1>
          <p>
            BlackRoth delivers intelligent AI-driven solutions that help businesses
            automate operations, drive smarter decision-making, and unlock competitive
            advantages through advanced machine learning and data analytics.
          </p>
        </div>

        {/* Overview */}
        <section className="page-section">
          <h2>Overview</h2>
          <p>
            Artificial Intelligence enables organizations to analyze data at scale,
            predict outcomes with precision, and automate repetitive processes efficiently.
            BlackRoth provides end-to-end AI solutions that transform business operations,
            enhance customer experiences, and accelerate innovation across industries.
          </p>
        </section>

        {/* Core Capabilities */}
        <section className="page-section">
          <h2>Core Capabilities</h2>
          <p>
            Our AI solutions are designed to address complex business challenges through
            intelligent automation, predictive analytics, and machine learning models that
            drive operational excellence and strategic growth.
          </p>
        </section>

        {/* Services */}
        <section className="page-section">
          <h2>Our AI Solutions</h2>
          <ul className="service-list">
            <li>Intelligent Automation - Automate business workflows and reduce manual effort</li>
            <li>Machine Learning - Predict trends and optimize business decisions</li>
            <li>AI Analytics - Turn raw data into meaningful business insights</li>
            <li>Natural Language Processing - Extract intelligence from unstructured text</li>
            <li>Computer Vision - Automated image and video analysis</li>
            <li>Predictive Modeling - Forecast business outcomes and risks</li>
            <li>AI Process Optimization - Streamline operations with intelligent algorithms</li>
            <li>AI-Powered Chatbots - Enhance customer support and engagement</li>
          </ul>
        </section>

        {/* Our Approach */}
        <section className="page-section">
          <h2>Our Approach</h2>
          <ol className="service-list">
            <li>Business Analysis - Understand your challenges and identify AI opportunities</li>
            <li>Data Preparation - Collect, clean, and organize relevant data</li>
            <li>Model Development - Build and train advanced machine learning models</li>
            <li>Testing & Validation - Ensure accuracy and reliability before deployment</li>
            <li>Deployment & Integration - Seamlessly integrate AI into your business systems</li>
            <li>Monitoring & Optimization - Continuously improve model performance</li>
          </ol>
        </section>

        {/* Business Value */}
        <section className="page-section">
          <h2>Business Value</h2>
          <p>
            BlackRoth's AI solutions help organizations reduce operational costs, improve
            decision-making speed, enhance customer satisfaction, enable innovation, and
            create competitive advantages in rapidly evolving markets.
          </p>
        </section>

        {/* Technology */}
        <section className="page-section">
          <h2>Technology & Integration</h2>
          <p>
            Our AI solutions integrate seamlessly with enterprise systems, cloud platforms,
            and data warehouses using modern machine learning frameworks, APIs, and secure
            cloud-based architectures for scalable and reliable performance.
          </p>
        </section>

        {/* Security */}
        <section className="page-section">
          <h2>Security & Compliance</h2>
          <p>
            BlackRoth ensures data privacy, model transparency, and regulatory compliance
            through secure data handling, encrypted communications, audit trails, and
            adherence to industry standards and data protection regulations.
          </p>
        </section>
      </div>
    </div>
  );
};

export default AISolutions;
